import { UseLoadingReturn } from "@/hooks/use-loading";
import coverageAreaService from "@/services/coverage-area.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type Return = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveCoverageArea = (): Return => {
  const response = useRemove({
    operation: (coverageAreaId) => coverageAreaService.delete(coverageAreaId),
  });

  const { isLoading, startLoading, endLoading, loadingIcon, remove } = response;

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemoveCoverageArea;
